import React from 'react';
import { RichEditorControl, SkinSelector } from '../CommonProperties';
import { usePropertyPanel } from '../PropertyPanelContext';
import { useSelector, useDispatch } from 'react-redux';
import { selectSelectedComponent, updateComponent } from '../../../redux/editorSlice';

const RichEditorProperties = () => {
  const { devicePropertyTab } = usePropertyPanel();
  const selectedComponent = useSelector(selectSelectedComponent);
  const dispatch = useDispatch();
  
  // 컴포넌트 속성 변경 핸들러 (SkinSelector 용)
  const handleComponentPropsChange = (property, value) => {
    if (!selectedComponent) return;
    
    const existingProps = JSON.parse(JSON.stringify(selectedComponent.componentProps || {}));
    existingProps[property] = value;
    
    dispatch(updateComponent({
      id: selectedComponent.id,
      changes: {
        componentProps: existingProps
      }
    }));
  };

  return (
    <>
      <SkinSelector 
        componentType={selectedComponent?.type}
        currentSkin={selectedComponent?.componentProps?.skin}
        onSkinChange={(skin) => handleComponentPropsChange('skin', skin)}
      />
      
      <div className="property-group">
        <RichEditorControl />
      </div>
    </>
  );
};

export default RichEditorProperties;
